import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, formatApiError } from "../lib/api";
import { tr } from "../lib/i18n";
import CaptionText from "../components/CaptionText";

// TEMPORARY review page (admin only) — remove before final delivery.
export default function SocialSamplesPage() {
  const [items, setItems] = useState(null);
  useEffect(() => {
    api.get("/social/samples").then(({ data }) => setItems(data)).catch((e) => { toast.error(formatApiError(e)); setItems([]); });
  }, []);
  return (
    <div data-testid="social-samples-page" className="max-w-6xl">
      <div className="kicker">{tr("x.social_media")}</div>
      <h1 className="mt-2" style={{ fontSize: 30, fontWeight: 600 }}>{tr("sg.samples_title")}</h1>
      <p className="text-sm text-amber-700 mt-2">{tr("sg.samples_help")}</p>
      {!items ? <div className="panel p-5 mt-5 text-sm">{tr("x.loading")}</div>
        : items.length === 0 ? <div className="panel p-5 mt-5 text-sm" data-testid="samples-empty">{tr("sg.no_samples")}</div>
        : <div className="space-y-6 mt-5">{items.map((s, i) => (
          <section key={s.id} className="panel p-4 space-y-3" data-testid={`sample-${i}`}>
            <h2 className="font-semibold">{s.car} · {tr(`sg.lang_${s.lang /* i18n-keys: en,ar,both */}`)} · {tr(`sg.t_${s.template /* i18n-keys: square,portrait,story,carousel */}`)}</h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
              <figure>
                <figcaption className="eyebrow mb-1">{tr("sg.original")}</figcaption>
                <img src={s.original_photos?.[0]} alt="" className="w-full rounded-lg border border-[var(--line)]" data-testid={`sample-original-${i}`} />
              </figure>
              <figure>
                <figcaption className="eyebrow mb-1">{tr("sg.poster")}</figcaption>
                {s.images.flatMap((set) => set.urls).map((u) => <a key={u} href={u} target="_blank" rel="noopener noreferrer"><img src={u} alt="" className="w-full rounded-lg border border-[var(--line)] bg-black" data-testid={`sample-poster-${i}`} /></a>)}
              </figure>
              <div>
                <div className="eyebrow mb-1">{tr("sg.caption")}</div>
                <CaptionText text={s.caption} testId={`sample-caption-${i}`} className="border border-[var(--line)] rounded-lg p-3" />
              </div>
            </div>
          </section>
        ))}</div>}
    </div>
  );
}
